class PdpSizeGuideHowTo extends HTMLElement {
  #drawer = null;
  #onTabChange = null;

  connectedCallback() {
    this.#drawer = this.closest('pdp-size-guide');
    this.#setActiveTab(this.#resolveActiveTab());

    this.#onTabChange = (event) => {
      const tab = event.detail?.tab;
      if (!tab) return;
      this.#setActiveTab(tab);
    };

    this.#drawer?.addEventListener('size-guide:tab-change', this.#onTabChange);
  }

  disconnectedCallback() {
    if (this.#drawer && this.#onTabChange) {
      this.#drawer.removeEventListener('size-guide:tab-change', this.#onTabChange);
    }

    this.#drawer = null;
    this.#onTabChange = null;
  }

  #resolveActiveTab() {
    const conversion = this.#drawer?.querySelector('pdp-size-guide-conversion');
    return conversion?.dataset.activeTab || conversion?.dataset.defaultTab || 'product';
  }

  #setActiveTab(tab) {
    const normalized = String(tab).trim().toLowerCase();
    const panels = this.querySelectorAll('[data-ref="how-to-panel"]');

    panels.forEach((panel) => {
      const panelTab = String(panel.dataset.tab ?? '').trim().toLowerCase();
      const isActive = panelTab === normalized;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', String(!isActive));
    });
  }
}

if (!customElements.get('pdp-size-guide-how-to')) {
  customElements.define('pdp-size-guide-how-to', PdpSizeGuideHowTo);
}
